// extracted by mini-css-extract-plugin
module.exports =  {"shareBtn":"shareBtn___LMhzv"};